import { Button, Modal } from "antd";
import TextArea from "antd/lib/input/TextArea";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { updateJob, updateSiteDetails } from "../../../../../Actions/RetailMatchActions";
import { IRetailMatchJob } from "../../../../../Models/IRetailMatch";
import { BodyText } from "../../../../Common/ReportStyles/Text";

interface RetailMatchIntroAddSiteDetailsProps {
    job: IRetailMatchJob;
    showAddSiteDetails: boolean;
    setShowAddSiteDetails: (show: boolean) => void;
}

const RetailMatchIntroAddSiteDetails = (props: RetailMatchIntroAddSiteDetailsProps): JSX.Element => {
    const dispatch = useDispatch();
    const { job, setShowAddSiteDetails, showAddSiteDetails } = props;
    const [siteDetailsText, setSiteDetailsText] = useState<string>("");
    const [loadingUpdateJob, setLoadingUpdateJob] = useState<boolean>();
    const maxLength = 750;

    const submitSiteDetailsUpdateRequest = () => {
        setLoadingUpdateJob(true);

        dispatch(
            updateSiteDetails(job.jobId, siteDetailsText, () => {
                setLoadingUpdateJob(false);
                setShowAddSiteDetails(false);
            })
        );
    };

    return (
        <Modal
            title="Add Site Details"
            visible={showAddSiteDetails}
            centered={true}
            onCancel={() => setShowAddSiteDetails(false)}
            footer={[
                <Button
                    key="submit"
                    type="primary"
                    htmlType="submit"
                    loading={loadingUpdateJob}
                    onClick={submitSiteDetailsUpdateRequest}
                    disabled={siteDetailsText.length > maxLength}
                >
                    Submit
                </Button>,
            ]}
        >
            <TextArea
                id="site-details"
                defaultValue={job.siteDetails}
                rows={7}
                maxLength={maxLength}
                allowClear={true}
                placeholder="add additional information about your site."
                onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
                    setSiteDetailsText(e.target.value)
                }
            />

            <BodyText style={{ marginTop: "5px", fontWeight: "bold" }}>
                Character count: {siteDetailsText.length} / {maxLength}
            </BodyText>
        </Modal>
    );
};

export default RetailMatchIntroAddSiteDetails;
